// @ts-nocheck
import { getItem, setItem, handleError } from '@/utilities';
import { siteApi } from '../services';
import config from './config';

function getCordIdFromUrl() {
  const url = window.location.href;
  const regex =
    /[?&]_cord_id=([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/;
  const found = url.match(regex);
  if (found) {
    history.replaceState(
      history.state,
      document.title,
      url.replace(
        /&?_cord_id=([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/,
        '',
      ),
    );
    return found[1];
  }
  return undefined;
}

class App {
  constructor() {
    this.auth = null;
    this.loaded = false;
    this.loading = false;
  }

  async initialize() {
    this.loading = true;
    this.auth = getItem({
      key: `concord-transient-token-${config.projectId}`,
    });
    if (config.auth) {
      this.auth = {
        ...this.auth,
        ...config.auth,
      };
    }
    siteApi.initialize({
      auth: this.auth,
      refreshSession: this.refreshSession.bind(this),
      projectId: config.projectId,
      siteApiUrl: config.baseUrl,
    });

    // if we don't have a session token in local storage, we need to refresh it
    if (!this.auth?.session) {
      await this.refreshSession();
    }

    this.loading = false;
    this.loaded = true;
  }

  async doRefreshSession() {
    const cordId = getCordIdFromUrl();
    let session = null;
    try {
      session = await siteApi.getSession(cordId);
      this.auth = {
        ...this.auth,
        session,
      };
    } catch (err) {
      handleError(err);
      // reset the session with a new one.
      this.auth = {
        ...this.auth,
        session: undefined, // clear the session
      };
    }
    setItem({
      key: `concord-transient-token-${config.projectId}`,
      value: this.auth,
    });
    siteApi.setAuthentication(this.auth);
  }

  clearSession() {
    this.auth = {
      ...this.auth,
      session: undefined, // clear the session
    };
    setItem({
      key: `concord-transient-token-${config.projectId}`,
      value: this.auth,
    });
    siteApi.setAuthentication(this.auth);
  }

  async refreshSession() {
    if (this.refreshPromise) {
      await this.refreshPromise;
      return;
    }
    this.refreshPromise = this.doRefreshSession();
    await this.refreshPromise;
    this.refreshPromise = null;
  }

  getContextId() {
    if (this.auth && this.auth.session) {
      return JSON.parse(atob(this.auth.session)).contextId;
    }
    return null;
  }
}

const app = new App();

export default app;
